import React from 'react';
import { Link } from 'react-router-dom';
import Styles from '../pages/styles.module.css';
import HomeStyles from './Home.module.css';
import { useTranslation } from 'react-i18next';
import Testimonials from '../components/Testimonials';
import logo from '../asset/Image/krushilogo.png';
import 'react-multi-carousel/lib/styles.css';

function Home() {
  const { t } = useTranslation();

  return (
    <div className={HomeStyles.homeAppContainer}>
      <section className={HomeStyles.heroSection}>
        <img
          className={HomeStyles.headerImage}
          src={require('../asset/Image/bgdairy.jpg')}
          alt="Dairy Farm"
        />
        <div className={HomeStyles.heroOverlay} />
        <div className={HomeStyles.heroContent}>
          <span className={HomeStyles.heroBadge}>{t('Farm Fresh Dairy')}</span>
          <h1 className={HomeStyles.headerTitle}>{t('Krushiratna Milk')}</h1>
          <p className={HomeStyles.headerSubTitle}>
            {t('Our focus on purity and freshness ensures every product is safe, nutritious, and delicious. From our farm to your table, we pride ourselves on sustainable farming and strict quality control.')}
          </p>
          <div className={HomeStyles.heroStats}>
            <span className={HomeStyles.heroStatItem}>{t('100% Fresh Milk')}</span>
            <span className={HomeStyles.heroStatItem}>{t('Daily Local Delivery')}</span>
            <span className={HomeStyles.heroStatItem}>{t('Trusted by Families')}</span>
          </div>
          <div className={HomeStyles.heroButtons}>
            <Link to="/products" className={HomeStyles.ctaButton}>
              {t('Explore Products')}
            </Link>
            <Link to="/enquiry" className={HomeStyles.secondaryButton}>
              {t('Contact Us')}
            </Link>
          </div>
        </div>
      </section>

      <section className={HomeStyles.logoBrandSection}>
        <div className={HomeStyles.logoBrandContainer}>
          <img src={logo} alt="Krushiratna Brand Logo" className={HomeStyles.homeLogo} />
          <p className={HomeStyles.logoBrandText}>{t('Serving Fresh Dairy Since 2018')}</p>
        </div>
      </section>

      <section className={HomeStyles.featuresSection}>
        <h2 className={HomeStyles.homeSectionHeading}>{t('Why Choose Krushiratna')}</h2>
        <div className={HomeStyles.featureGrid}>
          <div className={HomeStyles.featureCard}>
            <h3>{t('100% Fresh Milk')}</h3>
            <p>{t('Delivered daily from trusted farms with no preservatives and no compromise on goodness.')}</p>
          </div>
          <div className={HomeStyles.featureCard}>
            <h3>{t('Pure Natural Quality')}</h3>
            <p>{t('Our processing follows the highest hygiene standards to keep every drop wholesome and delicious.')}</p>
          </div>
          <div className={HomeStyles.featureCard}>
            <h3>{t('Trusted by Families')}</h3>
            <p>{t('Loved in every kitchen, our dairy products bring healthy nutrition to every meal.')}</p>
          </div>
        </div>
      </section>

      <section className={HomeStyles.homeTestimonialsContainer}>
        <div className={Styles.testimonials}>
          <h2>{t('What our customers say')}</h2>
          <Testimonials />
        </div>
      </section>
    </div>
  );
}

export default Home;
